import { z } from "zod";

export const demoRequestSchema = z.object({
  fullName: z.string()
    .min(2, "Le nom doit contenir au moins 2 caractères")
    .max(100, "Le nom est trop long"),
  email: z.string()
    .email("Email invalide")
    .max(255, "Email trop long"),
  phone: z.string()
    .regex(/^(\+41|0)[0-9]{9}$/, "Format invalide (ex: +41791234567 ou 0791234567)")
    .optional()
    .or(z.literal("")),
  establishmentName: z.string()
    .max(100, "Nom trop long")
    .optional()
    .or(z.literal("")),
  establishmentType: z.enum(["cafe", "restaurant", "brasserie", "autre", "non_renseigne"]).optional(),
  seatingCapacity: z.number()
    .int("Doit être un nombre entier")
    .positive("Doit être positif")
    .max(9999, "Nombre trop élevé")
    .optional()
    .nullable(),
  city: z.string()
    .max(100, "Nom de ville trop long")
    .optional()
    .or(z.literal("")),
  interestedPlan: z.enum(["standard", "founders", "undecided"]),
  message: z.string()
    .max(500, "Message trop long (max 500 caractères)")
    .optional()
    .or(z.literal("")),
  contactPreference: z.enum(["email", "phone", "any"]),
  honeypot: z.string().optional(), // Honeypot field for bot detection
});

export type DemoRequestFormData = z.infer<typeof demoRequestSchema>;
